import type { HomepageContent } from '@wix/wix-help-widget-common/homepage';
import type { UserExperience } from '@wix/wix-help-widget-common/personalization';
import { Brand } from '@wix/wix-help-widget-common/types';

import { HttpClientFactory } from '../../common/httpClient';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';

const { clientTopology } = renderModel.get();

const getBrand = (): Brand => {
  const queryParams = renderModel.getQueryParams();
  return (queryParams?.brand as Brand) || Brand.Wix;
};

export const getHomepageContent = async (
  httpClient: HttpClientFactory,
  parentUrl: string,
  userExperience?: UserExperience,
): Promise<HomepageContent> => {
  try {
    const response = await httpClient.getInstance().post<HomepageContent>(clientTopology.widgetHomepageUrl, {
      brand: getBrand(),
      userExperience,
      parentUrl,
      // Lets the CMS provider vary content where parentUrl cannot
      // (Studio 1 vs Studio 2.0 share a base URL).
      origin: renderModel.getQueryParams()?.origin,
    });
    return response.data;
  } catch (error) {
    logger.error({
      message: 'Failed to fetch Homepage Content',
      error,
    });
    console.error(error);
    throw error;
  }
};
